import axios from "axios";
export default {
  setNotifications(context, payload) {
    context.commit("setNotifications", payload);
  },
  addNotification(context, payload) {
    context.commit("addNotification", payload);
  },
  getNotifications(context) {
    let notification = [];
    axios.get("notification").then((res) => {
      notification = res.data.data;
      context.commit("setNotifications", notification);
      // context.commit("setUnreadNotifCount", res.data.unread_notifications);
    });
  },
  getUnreadNotifCount(context) {
    axios.get("notification/count_un_read").then((res) => {
      context.commit("setUnreadNotifCount", res.data.data);
    });
  },
};
